import { render } from "./MockPaper.vue?vue&type=template&id=10738aa6&scoped=true&ts=true"
import script from "./MockPaper.vue?vue&type=script&lang=ts"
export * from "./MockPaper.vue?vue&type=script&lang=ts"

import "./MockPaper.vue?vue&type=style&index=0&id=10738aa6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10738aa6"]])

export default __exports__